"use client";

import dynamic from "next/dynamic";
import React from "react";
import { MiniChartProps } from "react-ts-tradingview-widgets";

import { Lang } from "@/i18n-config";

const MiniWidget = dynamic(
  () => import("react-ts-tradingview-widgets").then((w) => w.MiniChart),
  { ssr: false }
);

type Props = {
  lang: Lang;
  symbol: string;
  noTimeScale?: boolean;
} & MiniChartProps;

export const TradingViewMiniWidget = React.memo<Props>(
  ({ lang, symbol, ...props }) => (
    <MiniWidget
      isTransparent
      autosize
      symbol={symbol}
      locale={lang === "zh" ? "zh_TW" : "en"}
      copyrightStyles={{
        parent: { color: "#D4D4D8" },
        span: { color: "#D4D4D8" },
      }}
      {...props}
    />
  )
);

TradingViewMiniWidget.displayName = "TradingViewMiniWidget";
